// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from "vuex"
import $ from 'jquery'


import tools from './util/tools.js'
Vue.prototype.tools = tools
window.eventBus = new Vue();
Vue.config.productionTip = false

//对axios的封装
import axios from 'axios'
import api from './api/index.js'
Vue.prototype.axios = axios
Vue.prototype.$api=api;

//mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)

//无限滚动
import dtInfiniteScroll from './util/dt-infinite-scroll/index.js'
Vue.use(dtInfiniteScroll)

//默认头像
Vue.prototype.teacherAvatar="/mooc-wx/static/img/default-teacher.png";
Vue.prototype.studentAvatar="/mooc-wx/static/img/default-student.png";
// Vue.prototype.teacherAvatar="../static/img/default-teacher.png";
// Vue.prototype.studentAvatar="../static/img/default-student.png";
//获取导航参数
function geturl_j(name){
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
//设置导航参数
function seturl_j(url, key, value) {
  // if(!value) {
  //   return uri;
  // }
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = url.indexOf('?') !== -1 ? "&" : "?";
  if (url.match(re)) {
    return url.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return url + separator + key + "=" + value;
  }
}
//表单验证
import VeeValidate,{ Validator } from "vee-validate"
import cn from 'vee-validate/dist/locale/zh_CN';
Vue.use(VeeValidate,{
  locale: 'zh_CN',
  dictionary: {
    "zh_CN": cn
  },
  events:""
});


Vue.use(Vuex)
var store=new Vuex.Store({
  state:{
    is_dsf:false,//是否第三方登录
    dl_url:'',//登录的跳转地址
    isLogin:false,
    //是否依附文化馆
    status:{
      isIn:null,
      url:null
    },
    firstlink: 0,
    isbindphone: 1,
    bind_link_url:'',
    mobile:''
  },
  mutations:{
    setmobile(state,mobile){
        state.mobile=mobile;
    },
    setLogin(state,status){
      if(status == 1){
        state.isLogin=true;
      }else{
        state.isLogin=false;
      }

    },
    setStatus(state,status){
      state.status.url=status.url;
      state.status.isIn=status.isIn;
    },
    setfirstlink(state){
      state.firstlink = 1;
    },
    setbindphone(state,status){
      state.isbindphone = status;
    },
    setbind_link_url(state,url){
      state.bind_link_url = url;
    }
  }
})
//在第一次进入时，如果cookie有token等信息，记录登录状态
/*if(tools.getCookie("user_type")!==null){
  store.commit("setLogin");
}*/

//获取慕课是否启用第三方登录
var statusPromise=api.get("",{
  api:'/v1/mooc_center/getCenter'
},res=>{
  //type 0 第三方 1 本慕课登录
  if(res.status == 1){
    if(res.data.type == 0){
      if(res.data.wx_login_link){
        store.commit("setStatus",{
          isIn:true,
          url:res.data.wx_login_link
        });
      }else{
        store.commit("setStatus",{
          isIn:false,
          url:'/login'
        });
      }
    }else{
      store.commit("setStatus",{
        isIn:false,
        url:"/login"
      });
    }
  }
});
var sw = false;
var a = 0;
var login_status = 0;//用于判断是否需要登录
//这段看看能否移进App.vue
router.beforeEach((to, from, next)=>{
  if(to.fullPath.indexOf('mooc-wx') == -1){
    next({
      replace:false,
      path:'/mooc-wx' + to.fullPath
    });
    return;
  }
  if(to.path == '/mooc-wx1/' || to.path == '/mooc-wx/'){
    next('/mooc-wx/error');
    return;
  }else if(to.path=='/mooc-wx/error'){
      next();
      return;
  }
  $.ajax({
    url: '/api/proxy/index',
    type:'get',
    async: false,
    data:{
      'api':'/v1/mooc_center/get_trial_status',
      v_key:geturl_j('v_key')
    },
    success: function(res){
      if(to.meta.type == 'error'){
        if(res.status == 1){
          router.replace('/mooc-wx/index');
          login_status = res.data.login_status;
        }else{
          if(to.path=='/mooc-wx/error'){
            next();
            return;
          }
        }
      }else{
        if(res.status == 1){
          login_status = res.data.login_status;
        }else{
          if(to.path=='/mooc-wx/error'){
            next();
            return;
          }else{
            next('/mooc-wx/error?v_key='+geturl_j('v_key'));
            // window.history.replaceState({}, '', '/mooc-wx/error');
            return;
          }
        }
      }
    }

  });
  if(to.fullPath.indexOf('v_key') == -1){
    a++;
    let url = to.fullPath;
    url = seturl_j(url,'v_key',geturl_j('v_key'));
    url = seturl_j(url,'login_status',login_status);
    // url = seturl_j(url,'t',new Date().getTime());
    next({
      replace:false,
      path:url
    });
    return;
  }
  if(to.meta.type == 'error'){
    next();
    return;
  }
  $.ajax({
    url: '/api/proxy/xuexitong_auto_login',
    type:'get',
    async: false,
    data:{
      v_key:geturl_j('v_key')
    },
    success: function(res){

    }
  });
  $.ajax({
    url: '/api/proxy/index',
    type:'get',
    async: false,
    data:{
      'api':'/v1/my/index',
      'user_type':1,
      // v_key:geturl_j('v_key')
    },
    success: function(res){
      if(res.status == 1){
        store.commit("setLogin",1);
      }else{
        store.commit("setLogin",0);
      }
    }

  });
  // alert(store.state.isLogin)
  //要去的页面需要登录，而又没登录
  if(to.meta.needLogin && !store.state.isLogin){
    //等待“获取是否在门户中”完成后判断
    statusPromise.then(()=>{
      if(store.state.status.isIn){
        window.location.replace(store.state.status.url + '?address=' + to.path.replace(/\//g,'*') + '&v_key=' + geturl_j('v_key'));
      }
      else{
        router.replace(store.state.status.url);
      }
    })
  }
  if(to.meta.needLogin && store.state.isLogin){
    //判断是否需要绑定手机号 0要绑定
    var statusphone=api.get("",{
      api:'/v1/user/is_rela',
      user_type:1
    },res=>{
      if(res.data == 0){
        store.commit("setbindphone",0);
      }
    })
    statusphone.then(()=>{
      store.commit("setbind_link_url",to.path);
      if(store.state.isbindphone == 0){
        router.replace("/bindphone");
      }
    })
  }
  document.title=to.meta.title;
  var bg=to.meta.background;
  if(!bg){
    bg="#f2f2f2";
  }
  document.getElementsByTagName("body")[0].style.backgroundColor=bg;
  $.ajax({
    url: '/api/proxy/in_menhu',
    dataType: 'json',
    type: 'get',
    data:{
      v_key:geturl_j('v_key')
    },
    success:function(res){
      $.ajax({
        url: '/api/proxy/index',
        type:'get',
        data:{
          'api':'/v1/mooc_center/update_pageview',
          center_id:res.data.center_id,
          v_key:geturl_j('v_key')
        },
        success: function(res){

        }
      });
      // $.ajax({
      //   url: 'https://demo-server.chaoxing.com/v1/mooc_center/update_pageview',
      //   dataType: 'json',
      //   type: 'get',
      //   data:{
      //     center_id:res.data.center_id
      //   },
      //   success:function(res){
      //
      //   }
      // })
    }
  })
  // if(sw){
    sw = false
  if ((to.path !== location.pathname) && !geturl_j('appId') && (!to.meta.no_href)) {
    if(location.pathname=='/mooc-wx/error'){
      // window.location.href = '/mooc-wx/error?v_key='+geturl_j('v_key');
      window.location.href = '/mooc-wx/error';
    }else{
      // window.location.href = to.fullPath;
      next()
    }
    // 此处不可使用location.replace
    // window.location.href = to.fullPath
  } else {
    next()
  }
  //   return
  // }

});

import loginDialog from '@/components/login-dialog/login-dialog.vue'
import customInput from '@/components/custom-input/custom-input.vue'
import accountDialog from '@/components/account-dialog/account-dialog.vue'
Vue.component("login-dialog",loginDialog)
Vue.component("custom-input",customInput)
Vue.component("account-dialog",accountDialog)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js